import { DateTime } from 'luxon';
import { AbstractFrontend } from '../../shared/core/abstract-prototype-object';
import { AbstractBackend } from '../abstract-contract';

export interface CoreItemBackend extends AbstractBackend {
  id: string;
  sk: string;

  ws: string;

  version: string;

  parentId?: string;

  title?: string;
  description?: string;

  isArchived?: boolean;

  responderId?: string;

  type?: any;

  // @deprecated Use unsafeSubData instead.
  subData?: any; // unsafeSubdata
  unsafeSubData?: any; //  ✅ Read, ✅ Write
  publicSubData?: any; //  ✅ Read, ❌ Write
  privateSubData?: any; // ❌ Read, ❌ Write

  userBoardConfig?: any;

  status?: string;
  statusMessage?: string;
  statusTimeStr?: string;

  scheduledTimeStr?: string;

  startTimeStr?: string;
  endTimeStr?: string;

  isPaid?: boolean;
}

export interface CoreItem extends AbstractFrontend {
  sk: string;

  coreType: CoreItemType;

  version: string;

  ws: string;

  type?: any;
  parentId?: string;

  title?: string;
  description?: string;

  isArchived?: boolean;

  subData?: any; // unsafeSubdata
  unsafeSubData?: any;
  publicSubData?: any;
  privateSubData?: any;

  userBoardConfig?: any;

  status?: any;
  statusMessage?: string;
  statusTime?: DateTime;

  scheduledTime?: DateTime;

  startTime?: DateTime;
  endTime?: DateTime;

  isPaid?: boolean;
}

export enum CoreItemType {
  sessionMessage = 'a',
  board = 'b',
  chat = 'c',
  creditHistory = 'd', // Deprecated
  report = 'e',
  referral = 'f', // Deprecated
  tag = 'g',
  sessionTemplate = 'h',
  session = 'i',
  objection = 'j',
  leads = 'k',
  goal = 'l',
  methodology = 'm',
  personality = 'n',
  company = 'o',
  product = 'p',
  relation = 'r',
  resume = 's',
  task = 't',
  workspace = 'w', // placeholder
  chatMessage = 'z', // deprecated
}

export enum VertexRelationType {
  has = 'h',
  isParent = 'p',
  isBefore = 'b',
  watches = 'w', // watch a board => favorite a board
}

export interface VertexRelationAdd {
  from?: string;
  to?: string;
  displayOrderId?: number;
  relation: VertexRelationType;
}

export interface VertexRelation {
  from: string; // id
  to: string; // id
  relation: VertexRelationType;
  createdTimeStr?: string;
  displayOrderId?: number;

  unsafeSubData?: any; //  ✅ Read, ✅ Write
  publicSubData?: any; //  ✅ Read, ❌ Write
  privateSubData?: any; // ❌ Read, ❌ Write
}
